import {
	imgCollegesAlabamaWebp,
	imgCollegesArizonaStateWebp,
	imgCollegesArizonaWebp,
	imgCollegesArkansasWebp,
	imgCollegesAuburnWebp,
	imgCollegesBaylorWebp,
	imgCollegesBostonCollegeWebp,
	imgCollegesBYUWebp,
	imgCollegesCaliforniaWebp,
	imgCollegesCincinattiWebp,
	imgCollegesClemsonWebp,
	imgCollegesColoradoWebp,
	imgCollegesDukeWebp,
	imgCollegesFloridaWebp,
	imgCollegesFSUWebp,
	imgCollegesGeorgiaTechWebp,
	imgCollegesGeorgiaWebp,
	imgCollegesGramblingWebp,
	imgCollegesHawaiiWebp,
	imgCollegesHoustonWebp,
	imgCollegesIllinoisWebp,
	imgCollegesIndianaWebp,
	imgCollegesIowaStateWebp,
	imgCollegesIowaWebp,
	imgCollegesKansasStateWebp,
	imgCollegesKansasWebp,
	imgCollegesKentuckyWebp,
	imgCollegesLouisvilleWebp,
	imgCollegesLSUWebp,
	imgCollegesMarylandWebp,
	imgCollegesMiamiWebp,
	imgCollegesMichiganStateWebp,
	imgCollegesMichiganWebp,
	imgCollegesMinnesotaWebp,
	imgCollegesMississippiStateWebp,
	imgCollegesMissouriWebp,
	imgCollegesNCStateWebp,
	imgCollegesNebraskaWebp,
	imgCollegesNorthCarolinaWebp,
	imgCollegesNorthwesternWebp,
	imgCollegesOhioStateWebp,
	imgCollegesOklahomaStateWebp,
	imgCollegesOklahomaWebp,
	imgCollegesOleMissWebp,
	imgCollegesOregonStateWebp,
	imgCollegesOregonWebp,
	imgCollegesPennStateWebp,
	imgCollegesPittsburgWebp,
	imgCollegesPurdueWebp,
	imgCollegesRutgersWebp,
	imgCollegesSouthCarolinaWebp,
	imgCollegesStanfordWebp,
	imgCollegesSyracuseWebp,
	imgCollegesTCUWebp,
	imgCollegesTennesseeWebp,
	imgCollegesTexasAMWebp,
	imgCollegesTexasTechWebp,
	imgCollegesTexasWebp,
	imgCollegesUCFWebp,
	imgCollegesUCLAWebp,
	imgCollegesUSCWebp,
	imgCollegesUtahWebp,
	imgCollegesVanderbiltWebp,
	imgCollegesVirginiaTechWebp,
	imgCollegesVirginiaWebp,
	imgCollegesWakeForestWebp,
	imgCollegesWashingtonStateWebp,
	imgCollegesWashingtonWebp,
	imgCollegesWestVirginiaWebp,
	imgCollegesWisconsinWebp,
} from '~/src/images';

export default {
	Alabama: imgCollegesAlabamaWebp,
	Arizona: imgCollegesArizonaWebp,
	ArizonaState: imgCollegesArizonaStateWebp,
	Arkansas: imgCollegesArkansasWebp,
	Auburn: imgCollegesAuburnWebp,
	Baylor: imgCollegesBaylorWebp,
	BostonCollege: imgCollegesBostonCollegeWebp,
	BYU: imgCollegesBYUWebp,
	California: imgCollegesCaliforniaWebp,
	Cincinatti: imgCollegesCincinattiWebp,
	Clemson: imgCollegesClemsonWebp,
	Colorado: imgCollegesColoradoWebp,
	Duke: imgCollegesDukeWebp,
	Florida: imgCollegesFloridaWebp,
	FSU: imgCollegesFSUWebp,
	Georgia: imgCollegesGeorgiaWebp,
	GeorgiaTech: imgCollegesGeorgiaTechWebp,
	Grambling: imgCollegesGramblingWebp,
	Hawaii: imgCollegesHawaiiWebp,
	Houston: imgCollegesHoustonWebp,
	Illinois: imgCollegesIllinoisWebp,
	Indiana: imgCollegesIndianaWebp,
	Iowa: imgCollegesIowaWebp,
	IowaState: imgCollegesIowaStateWebp,
	Kansas: imgCollegesKansasWebp,
	KansasState: imgCollegesKansasStateWebp,
	Kentucky: imgCollegesKentuckyWebp,
	Louisville: imgCollegesLouisvilleWebp,
	LSU: imgCollegesLSUWebp,
	Maryland: imgCollegesMarylandWebp,
	Miami: imgCollegesMiamiWebp,
	Michigan: imgCollegesMichiganWebp,
	MichiganState: imgCollegesMichiganStateWebp,
	Minnesota: imgCollegesMinnesotaWebp,
	MississippiState: imgCollegesMississippiStateWebp,
	Missouri: imgCollegesMissouriWebp,
	NCState: imgCollegesNCStateWebp,
	Nebraska: imgCollegesNebraskaWebp,
	NorthCarolina: imgCollegesNorthCarolinaWebp,
	Northwestern: imgCollegesNorthwesternWebp,
	OhioState: imgCollegesOhioStateWebp,
	Oklahoma: imgCollegesOklahomaWebp,
	OklahomaState: imgCollegesOklahomaStateWebp,
	OleMiss: imgCollegesOleMissWebp,
	Oregon: imgCollegesOregonWebp,
	OregonState: imgCollegesOregonStateWebp,
	PennState: imgCollegesPennStateWebp,
	Pittsburg: imgCollegesPittsburgWebp,
	Purdue: imgCollegesPurdueWebp,
	Rutgers: imgCollegesRutgersWebp,
	SouthCarolina: imgCollegesSouthCarolinaWebp,
	Stanford: imgCollegesStanfordWebp,
	Syracuse: imgCollegesSyracuseWebp,
	TCU: imgCollegesTCUWebp,
	Tennessee: imgCollegesTennesseeWebp,
	Texas: imgCollegesTexasWebp,
	TexasAM: imgCollegesTexasAMWebp,
	TexasTech: imgCollegesTexasTechWebp,
	UCF: imgCollegesUCFWebp,
	UCLA: imgCollegesUCLAWebp,
	USC: imgCollegesUSCWebp,
	Utah: imgCollegesUtahWebp,
	Vanderbilt: imgCollegesVanderbiltWebp,
	Virginia: imgCollegesVirginiaWebp,
	VirginiaTech: imgCollegesVirginiaTechWebp,
	WakeForest: imgCollegesWakeForestWebp,
	Washington: imgCollegesWashingtonWebp,
	WashingtonState: imgCollegesWashingtonStateWebp,
	WestVirginia: imgCollegesWestVirginiaWebp,
	Wisconsin: imgCollegesWisconsinWebp,
};
